var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolicity9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 0C126.522 0 151.957 10.5357 170.711 29.2893C189.464 48.043 200 73.4784 200 100C200 126.522 189.464 151.957 170.711 170.711C151.957 189.464 126.522 200 100 200H24C17.6348 200 11.5303 197.471 7.02944 192.971C2.52856 188.47 0 182.365 0 176L0 100C0 73.4784 10.5357 48.043 29.2893 29.2893C48.043 10.5357 73.4784 0 100 0V0Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.09 180.56L70.26 169.56L102.26 126.17C100.53 126.4 99.06 126.58 97.84 126.69C96.62 126.8 95.65 126.86 94.84 126.86C84.0267 126.86 74.6634 122.75 66.75 114.53C62.9332 110.646 59.9284 106.04 57.911 100.982C55.8936 95.9241 54.904 90.5148 55 85.07C54.9119 79.2182 56.0286 73.4109 58.2805 68.0091C60.5324 62.6072 63.8714 57.7264 68.09 53.67C72.1817 49.4523 77.0912 46.1141 82.5179 43.8599C87.9446 41.6056 93.7743 40.4828 99.65 40.56C105.546 40.5013 111.395 41.6141 116.857 43.8337C122.319 46.0533 127.286 49.3355 131.47 53.49C140.49 62.07 145 72.1933 145 83.86C145 94.2067 140.607 105.39 131.82 117.41L85.09 180.56ZM74.68 83.56C74.6376 86.9086 75.2617 90.2322 76.516 93.3373C77.7703 96.4424 79.6297 99.267 81.9861 101.647C84.3424 104.026 87.1486 105.913 90.2412 107.198C93.3339 108.483 96.6512 109.14 100 109.13C106.688 109.149 113.11 106.513 117.857 101.802C122.604 97.0903 125.288 90.688 125.32 84C125.319 80.6715 124.659 77.376 123.38 74.3032C122.1 71.2304 120.226 68.4409 117.864 66.0952C115.503 63.7495 112.701 61.8938 109.62 60.635C106.538 59.3761 103.239 58.7389 99.91 58.76C96.605 58.7073 93.3241 59.3303 90.2684 60.5907C87.2127 61.8512 84.4467 63.7225 82.14 66.09C79.7635 68.342 77.8751 71.0583 76.5918 74.0704C75.3086 77.0824 74.6578 80.326 74.68 83.6V83.56Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 100,
    x2: 200,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E81894"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolicity9);
export default __webpack_public_path__ + "static/media/volicity-9.8d253c45229b80926ef9b6e86f17e96e.svg";
export { ForwardRef as ReactComponent };